import { useQuery } from "@tanstack/react-query";
import { checkPrescriptionOrder } from "../services/ePrescriptionDetailService";

export const usePrescriptionOrder = (
  prescriptionId?: string,
  token?: string | null
) => {
  return useQuery({
    queryKey: ["prescription-order", prescriptionId],
    queryFn: () => checkPrescriptionOrder(prescriptionId!, token!),

    enabled: !!prescriptionId && !!token,

    staleTime: 0,
    refetchOnWindowFocus: true,
  });
};